import { useDispatch } from 'react-redux';
import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import React from 'react';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import AGBModalCustomization from '../customizations/AGBModalCustomization';

const AGBModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.AGB_MODAL));
	};
	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('footer.conditions')}>
			<ModalClose onClose={handleOnCloseModal} />
			<AGBModalCustomization />
		</Modal>
	);
};

export default AGBModal;
